import { config } from './config.debug';

function getConfig() {
  return config;
}
export { getConfig };

